<div class="main-content">
  <markdown [src]="privacyPath"></markdown>
</div>
